import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './Radio.module.css';
import { RadioProps } from './Radio.types';

const Radio = forwardRef<HTMLInputElement, RadioProps>(({ id, label, checked, disabled, className, ...props }, ref) => (
  <div className={styles.container}>
    <input
      {...props}
      ref={ref}
      type="radio"
      data-testid={`radio-input-${id}`}
      id={id}
      checked={checked}
      aria-checked={checked}
      aria-disabled={disabled ? 'true' : 'false'}
      disabled={disabled}
      className={classNames(styles.radio, { [className!]: className !== undefined })}
    />
    <svg width="24px" height="24px">
      <circle cx="12" cy="12" r="8" />
    </svg>
    <label htmlFor={id} className={classNames(styles.label, { [styles.disabled]: disabled })}>
      {label}
    </label>
  </div>
));

Radio.displayName = 'Radio';

export default Radio;
